// extracted by mini-css-extract-plugin
export default {"card":"_7Ijj6","category":"zDz-e","title":"mOXiQ","topics":"ChO+v","topShadow":"_5mQST","cardSmall":"JT+SQ","withLink":"wf5X6"};